import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Layout from "./components/app/Layout";
import Briefing from "./pages/Briefing";
import Dashboard from "./pages/Dashboard";
import Propales from "./pages/Propales";
import Clients from "./pages/Clients";
import Settings from "./pages/Settings";
import MorningBrief from "./pages/MorningBrief";
import "./App.css";

function Private({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 text-sm" style={{ color: "var(--th-text-3)" }}>Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Private><Layout /></Private>}>
              <Route index element={<Navigate to="/briefing" replace />} />
              <Route path="briefing" element={<Briefing />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="brief-matin" element={<MorningBrief />} />
              <Route path="propales" element={<Propales />} />
              <Route path="clients" element={<Clients />} />
              <Route path="reglages" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}
